/*
 *
 * TermsRedirect
 *
 * The live movebooth.com Terms page is canonical; the old in-app copy is gone.
 * /terms forwards there (replace, so Back does not loop). The visible link is
 * a fallback if location.replace is blocked or slow. It is not a no-JS path:
 * the SPA renders nothing until React runs.
 *
 */

import React, { useEffect } from 'react';
import { MARKETING_TERMS_URL } from 'utils/marketing';

const TermsRedirect = () => {
  useEffect(() => {
    window.location.replace(MARKETING_TERMS_URL);
  }, []);

  return (
    <p>
      <a href={MARKETING_TERMS_URL}>Continue to the Terms</a>
    </p>
  );
};

export default TermsRedirect;
